var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export default function addOrRemoveFromArray(array, value, compare) {
    if (compare === void 0) { compare = function (a, b) { return a === b; }; }
    var index = array.findIndex(function (arrayValue) { return compare(arrayValue, value); });
    if (index >= 0) {
        array.splice(index, 1);
    }
    else {
        array.push(value);
    }
    return __spreadArrays(array);
}
